import { StateCreator } from 'zustand';
import { HealthMarkerConversion, NewHealthMarker } from 'src/core/types/HealthMarkerReport';

export interface MarkerSlice {
  latestMarkers: Array<NewHealthMarker>;
  favoriteMarkers: Array<NewHealthMarker>;
  allMarkerConversions: Array<HealthMarkerConversion>;
  setLatestMarkers: (allMarkers: Array<NewHealthMarker>) => void;
  setFavoriteMarkers: (favoriteMarkers: Array<NewHealthMarker>) => void;
  setAllMarkerConversions: (allMarkerConversions: Array<HealthMarkerConversion>) => void;
}

export const createMarkerSlice: StateCreator<MarkerSlice, [], [], MarkerSlice> = (set) => ({
  latestMarkers: [],
  favoriteMarkers: [],
  allMarkerConversions: [],
  setLatestMarkers: (latestMarkers: Array<NewHealthMarker>) => set(() => ({ latestMarkers })),
  setFavoriteMarkers: (favoriteMarkers: Array<NewHealthMarker>) => set(() => ({ favoriteMarkers })),
  setAllMarkerConversions: (allMarkerConversions: Array<HealthMarkerConversion>) =>
    set(() => ({ allMarkerConversions }))
});
